// extracted by mini-css-extract-plugin
module.exports = {"group":"apiError_group__3VPhR","btn":"apiError_btn__2LViM"};